import React from "react";

const ServerClient = ({
  height = "24",
  width = "24",
  viewBox = "0 0 24 24",
  color = "#000"
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={height}
    height={width}
    viewBox={viewBox}
  >
    <g fill="none" fillRule="evenodd" transform="translate(0 0)">
      <polygon points="0 0 24 0 24 24 0 24" />
      <path
        fill={color}
        fillRule="nonzero"
        d="M19,15 L19,19 L5,19 L5,15 L19,15 M20,13 L4,13 C3.45,13 3,13.45 3,14 L3,20 C3,20.55 3.45,21 4,21 L20,21 C20.55,21 21,20.55 21,20 L21,14 C21,13.45 20.55,13 20,13 Z M7,18.5 C6.18,18.5 5.5,17.83 5.5,17 C5.5,16.17 6.18,15.5 7,15.5 C7.82,15.5 8.5,16.17 8.5,17 C8.5,17.83 7.83,18.5 7,18.5 Z M19,5 L19,9 L5,9 L5,5 L19,5 M20,3 L4,3 C3.45,3 3,3.45 3,4 L3,10 C3,10.55 3.45,11 4,11 L20,11 C20.55,11 21,10.55 21,10 L21,4 C21,3.45 20.55,3 20,3 Z M7,8.5 C6.18,8.5 5.5,7.83 5.5,7 C5.5,6.17 6.18,5.5 7,5.5 C7.82,5.5 8.5,6.18 8.5,7 C8.5,7.82 7.83,8.5 7,8.5 Z"
      />
    </g>
  </svg>
);

export default ServerClient;
